import { PromotionCategoryList, PromotionCategoryEdit, PromotionCategoryCreate } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

export default {
    pages: {
        PromotionCategoryList,
        PromotionCategoryEdit,
        PromotionCategoryCreate,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name: 'promotionCategory',
    icon: 'fa-columns',
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/PromotionCategory/index.ts